import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { twMerge } from 'tailwind-merge';
import { PostCall } from '../../../hooks/api/usePostCall';
import { Subheader } from '../post-call-form';
import { RadioButton } from '../../radio-button';

const describeOptions = ['Amazing', 'Great', 'Good', 'Ok', 'Not Great'];

export interface DescribeStepProps {
  postCall?: PostCall;
  className?: string;
}

export const DescribeStep: React.FC<DescribeStepProps> = ({ postCall, className }) => {
  const { control } = useFormContext();

  return (
    <div className={twMerge('flex flex-col gap-6', className)}>
      <Subheader
        question={
          <>
            How would you describe your call with{' '}
            <span className="font-bold">{postCall?.call.listener_role.user.display_name}</span>?
          </>
        }
        postCall={postCall}
      />

      <div className="flex flex-col gap-2">
        {describeOptions.map((item: string) => (
          <Controller
            key={item}
            control={control}
            name="description"
            render={({ field: { value, onChange } }) => (
              <label
                htmlFor={`describe-${item}`}
                onClick={() => onChange(item)}
                className={twMerge(
                  'flex cursor-pointer items-center gap-3 rounded-[12px] border px-4 py-3 transition-colors',
                  value === item
                    ? 'border-selected-border bg-selected-bg'
                    : 'border-input-border-gray bg-gray-50 hover:bg-gray-100',
                )}
              >
                <RadioButton
                  checked={value === item}
                  onChange={() => onChange(item)}
                  data-testid={`describe-option-${item}`}
                />
                <span className="text-label-gray font-['Albert_Sans'] text-base font-medium leading-5">{item}</span>
              </label>
            )}
          />
        ))}
      </div>
    </div>
  );
};
